<template>
    <div class="flex flex-col gap-10">
        <div>
            <h3>{{ linkText }}</h3>
            <div class="flex gap-4">
                <div class="w-full">

                </div>
                <div class="hidden lg:block text-right my-4 flex-1 whitespace-nowrap w-fit"
                     v-if="latestPublishedPageUrl !== null">
                    <Link :href="latestPublishedPageUrl" text="Se alle publiseringer"/>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <a v-for="result in results"
               :href="result.url"
               :key="result.title"
               class="bg-sand rounded group h-full">
                <div class="relative w-full overflow-hidden">
                    <div v-if="result.tema" class="absolute top-0 left-0 p-2 ">
                        <div class="w-fit">
                            <h3 class=" px-3 py-2 bg-white inline-block uppercase text-gray-600 text-sm w-fit">
                                {{ result.tema }}
                            </h3>
                        </div>
                    </div>
                    <div class="w-full aspect-video">
                        <img alt="" :src="`${result.image}?${imageParams}&${result.imageResizerParams}`"/>
                    </div>
                </div>
                <div class="p-5 h-[230px]">
                    <p v-if="result.author" class="mb-1 text-sm truncate text-gray-600">
                        {{ result.author }}
                    </p>
                    <p class=" text-base font-semibold group-hover:underline line-clamp lines-5 ">{{ result.title }}</p>
                </div>
            </a>
        </div>
        <div class="lg:hidden w-full" v-if="latestPublishedPageUrl !== null">
            <Link :href="latestPublishedPageUrl" text="Se alle publiseringer"/>
        </div>
    </div>
</template>

<script>
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';
import LinedHeader from '@/Scripts/components/atoms/LinedHeader/LinedHeader.vue';
import Tag from '@/Scripts/components/atoms/Tag/Tag.vue';
import Link from '@/Scripts/components/atoms/Link/Link.vue';

export default {
    props: ['results', 'model'],
    components: {
        Link,
        Tag,
        EpiLink,
        LinedHeader,
    },
    data() {
        return {
            imageParams: 'scale=both&width=576&height=359',
            latestPublishedPageUrl: null,
            dateOptions: {year: 'numeric', month: '2-digit', day: '2-digit'},
            linkText: 'Nye publiseringer',
        };
    },
    mounted() {
        this.latestPublishedPageUrl = (this.model.latestPublishedPageUrl && this.model.latestPublishedPageUrl.value && this.model.latestPublishedPageUrl.value.url) ? this.model.latestPublishedPageUrl.value.url : null;
    },
};
</script>
